import { render, staticRenderFns } from "./step-description-text.vue?vue&type=template&id=da8dec76"
import script from "./step-description-text.vue?vue&type=script&lang=ts"
export * from "./step-description-text.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports